import { investmentJoinAndAllocationContext } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/InvestmentJoinAndAllocation';
import { useInvestmentJoinAndAllocationController } from '@dealstack/frontend/investor/pages/Investment/InvestmentJoinAndAllocation/useInvestmentJoinAndAllocationController';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';

interface Props {
	children: React.ReactNode;
}

export const DocumentsContextProvider = ({ children }: Props) => {
	const { mipId, dealId } = useParams();

	const [isContinueDisabled, setIsContinueDisabled] = useState(false);

	const value = useMemo(
		() =>
			({
				setIsContinueDisabled,
				isContinueDisabled,
				mipId,
				dealId,
			}) as ReturnType<typeof useInvestmentJoinAndAllocationController>,
		[isContinueDisabled, mipId, dealId]
	);

	return (
		<investmentJoinAndAllocationContext.Provider value={value}>
			{children}
		</investmentJoinAndAllocationContext.Provider>
	);
};
